"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationStep = void 0;
var _react = require("react");
var _common = require("../../common");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PaginationStep = ({
  autoplay,
  hidden,
  isActive,
  isNext,
  isPrevious,
  pagination,
  slideIndex,
  onPaginationStepClick,
  renderPaginationStep
}) => {
  const onClick = (0, _react.useCallback)(() => {
    onPaginationStepClick?.(slideIndex);
  }, [onPaginationStepClick, slideIndex]);
  if (renderPaginationStep) {
    return renderPaginationStep({
      autoplay,
      hidden,
      isActive,
      isNext,
      isPrevious,
      pagination,
      slideIndex,
      onPaginationStepClick: onClick
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PaginationStepRoot, {
    isActive: isActive,
    pagination: pagination,
    onClick: onClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PaginationStepInner, {
      autoplay: autoplay,
      className: isActive ? 'active-pagination-step' : undefined,
      "data-testid": _common.PAGINATION_STEP,
      hidden: hidden,
      isActive: isActive,
      isNext: isNext,
      isPrevious: isPrevious,
      pagination: pagination
    })
  });
};
exports.PaginationStep = PaginationStep;
//# sourceMappingURL=PaginationStep.js.map